export default ({ app }) => {
  app.router.beforeEach((to, from, next) => {
    if (from.query.noBrand && !to.query.noBrand) {
      next({ path: to.path, query: { ...to.query, noBrand: "true" } });
    } else {
      next();
    }
  });
};
